<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Certificate</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
<!--          <button @click="updateExchangeRate()" type="button" class="btn btn-white btn-icon-text my-2 mr-2">-->
<!--            <i class="fe fe-refresh-cw mr-2"></i> Update Exchange Rate-->
<!--          </button>-->
<!--          <button type="button" class="btn btn-white btn-icon-text my-2 mr-2">-->
<!--            <i class="fe fe-filter mr-2"></i> Filter-->
<!--          </button>-->
          <router-link to="/certificate/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add Certificate
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Certificate List</h6>
            </div>
            <div class="table-responsive">
              <div class="form-group mt-1 ml-1" style="width: 280px">
                <div class="d-flex">
                  <div class="input-group rounded">
                    <input type="search" class="form-control rounded" v-model="searchText" v-on:keyup.enter="search" placeholder="Search"/>
                    <button type="button" class="border-0 btn btn-primary" @click="search">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="dataList" :fields="tableFields">
                <template #cell(is_paid)="row">
                  <p v-if="row.item.is_paid">YES</p>
                  <p v-else>NO</p>
                </template>
                <template #cell(is_used)="row">
                  <p v-if="row.item.is_used">YES</p>
                  <p v-else>NO</p>
                </template>
                <template #cell(is_seen)="row">
                  <p v-if="row.item.is_seen">YES</p>
                  <p v-else>NO</p>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/certificate/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="removeItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'Currency',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      searchText: '',
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      dataList: state => state.certificate.dataList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'bought_by_user.email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'currency.symbol',
          label: 'Currency',
          sortable: true
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: true
        },
        {
          key: 'is_paid',
          label: 'Is paid',
          sortable: true
        },
        {
          key: 'is_used',
          label: 'Is used',
          sortable: true
        },
        {
          key: 'is_seen',
          label: 'Is Seen',
          sortable: true
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getData({ count: this.paginationPerPage })
  },
  methods: {
    ...mapActions({
      getAllData: 'certificate/getAllData',
      deleteItem: 'certificate/delete'
    }),
    getData (params) {
      this.getAllData(params).then(res => {
        this.pagination = res.pagination
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    search () {
      this.getData({ page: this.paginationCurrentPage, count: this.paginationPerPage, search: this.searchText })
    },
    changePaginationPerPage (value) {
      this.getData({ page: this.paginationCurrentPage, count: value, search: this.searchText })
    },
    changePagination (page) {
      this.getData({ page: page, count: this.paginationPerPage, search: this.searchText })
    },
    removeItem (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteItem({ id }).then(res => {
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style>
  .is_main {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    cursor: pointer;
  }
</style>
